import React from 'react';
import Icon from '../../../components/AppIcon';

const VisibilityToggle = ({ isPublic, onChange }) => {
  return (
    <div className="w-full">
      <label className="text-sm md:text-base font-medium text-foreground mb-3 block">
        공개 설정
      </label>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`flex items-center space-x-3 md:space-x-4 p-4 md:p-5 rounded-lg border-2 transition-gaming ${
            isPublic
              ? 'border-primary bg-primary/10 shadow-gaming-sm'
              : 'border-border bg-card hover:border-muted hover:bg-muted/30'
          }`}
        >
          <div
            className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center ${
              isPublic ? 'bg-primary/20' : 'bg-muted'
            }`}
          >
            <Icon
              name="Globe"
              size={20}
              color={isPublic ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
              className="md:w-6 md:h-6"
            />
          </div>
          <div className="flex-1 text-left">
            <div
              className={`text-sm md:text-base font-semibold mb-1 ${
                isPublic ? 'text-primary' : 'text-foreground'
              }`}
            >
              공개
            </div>
            <div className="text-xs md:text-sm text-muted-foreground caption">
              모든 사용자가 볼 수 있습니다
            </div>
          </div>
          {isPublic && (
            <Icon name="CheckCircle" size={20} color="var(--color-primary)" />
          )}
        </button>

        <button
          type="button"
          onClick={() => onChange(false)}
          className={`flex items-center space-x-3 md:space-x-4 p-4 md:p-5 rounded-lg border-2 transition-gaming ${
            !isPublic
              ? 'border-primary bg-primary/10 shadow-gaming-sm'
              : 'border-border bg-card hover:border-muted hover:bg-muted/30'
          }`}
        >
          <div
            className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center ${
              !isPublic ? 'bg-primary/20' : 'bg-muted'
            }`}
          >
            <Icon
              name="Lock"
              size={20}
              color={!isPublic ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
              className="md:w-6 md:h-6"
            />
          </div>
          <div className="flex-1 text-left">
            <div
              className={`text-sm md:text-base font-semibold mb-1 ${
                !isPublic ? 'text-primary' : 'text-foreground'
              }`}
            >
              비공개
            </div>
            <div className="text-xs md:text-sm text-muted-foreground caption">
              나만 볼 수 있습니다
            </div>
          </div>
          {!isPublic && (
            <Icon name="CheckCircle" size={20} color="var(--color-primary)" />
          )}
        </button>
      </div>
    </div>
  );
};

export default VisibilityToggle;